import Vue from 'vue';
import VueI18n from 'vue-i18n';

import Api from '../services/api';
import { useMemoize } from '@vueuse/core';
import pluralizationRules from './pluralizationRules';
import { getCurrentLocale } from '../../assets/js/helpers/helper';

Vue.use(VueI18n);

const FALLBACK_LOCALE = 'en';
export const NO_TRANSLATION_QUERY = 'translation-slugs'

export const i18n = new VueI18n({
  locale: getCurrentLocale() || FALLBACK_LOCALE,
  pluralizationRules,
});

let publicMessagesPromise = null;
let memberMessagesPromise = null;

export const hasNoTranslationParam = () => {
  if (process.env.DEPLOYMENT_ENV === 'prod') return false;
  return new URLSearchParams(window.location.search).has(NO_TRANSLATION_QUERY);
}

const loadMessages = useMemoize(async function(scope, locale) {
  return await Api().get('https://' + FRONT_CDN_HOST + `/translations/${scope}.${locale}.json`).then(({ data }) => data);
})

const loadFallbackMessages = async () => {
  const fallbackTranslates = await import('./translates/fallback.json').then((res) => res.default);
  i18n.mergeLocaleMessage(FALLBACK_LOCALE, fallbackTranslates);
};

const loadPublicMessages = async (locale) => {
  if (hasNoTranslationParam()) {
    return;
  }

  try {
    const messages = await loadMessages('public', locale);
    i18n.mergeLocaleMessage(locale, messages);
  } catch {
    await loadFallbackMessages();
  }
};

const loadMemberMessages = async (locale) => {
  if (hasNoTranslationParam()) {
    return;
  }

  try {
    const messages = await loadMessages('member', locale);
    i18n.mergeLocaleMessage(locale, messages);
  } catch {
    await loadFallbackMessages();
  }
};

export const initPublicMessages = () => {
  if (publicMessagesPromise) {
    return publicMessagesPromise;
  }

  publicMessagesPromise = loadPublicMessages(i18n.locale);

  return publicMessagesPromise;
};

export const initMemberMessages = () => {
  if (memberMessagesPromise) {
    return memberMessagesPromise;
  }

  memberMessagesPromise = loadMemberMessages(i18n.locale);

  return memberMessagesPromise;
};

initPublicMessages();
